type Props = {
  socket: any;
  isLocked: boolean;
  handleFlowSelect?: any;
  handleAgree?: any;
  closeDialog?: any;
  openCloseDialog?: any;
  onCloseAgree?: any;
  cancelCloseDialog?: any;
  handleNextButtonClick?: any;
  moveToPrevStep?: any;
  moveToStep?: any;
};

export const useSocket = ({
  socket,
  isLocked,
  handleFlowSelect,
  handleAgree,
  closeDialog,
  openCloseDialog,
  onCloseAgree,
  cancelCloseDialog,
  handleNextButtonClick,
  moveToPrevStep,
  moveToStep,
}: Props) => {
  if (isLocked) {
    socket.on('select_flow', (flow) => {
      console.log('socket.on(select_flow');
      if (handleFlowSelect) {
        console.log('handleFlowSelect', flow);
        handleFlowSelect(flow, true);
      }
    });

    socket.on('agree_flow', (flow) => {
      if (handleAgree) {
        handleAgree(flow, true);
      }
    });

    socket.on('close_flow_dialog', () => {
      if (closeDialog) {
        closeDialog(true);
      }
    });

    socket.on('open_close_flow_dialog', () => {
      if (openCloseDialog) {
        openCloseDialog(true);
      }
    });

    socket.on('close_flow_agree', () => {
      if (onCloseAgree) {
        onCloseAgree(true);
      }
    });

    socket.on('cancel_flow_dialog', () => {
      if (cancelCloseDialog) {
        cancelCloseDialog(true);
      }
    });

    socket.on('flow_next_btn_click', (nb) => {
      if (handleNextButtonClick) {
        handleNextButtonClick(nb, true);
      }
    });

    socket.on('flow_moveto_prev_step', () => {
      if (moveToPrevStep) {
        moveToPrevStep(true);
      }
    });

    socket.on('flow_moveto_step', () => {
      if (moveToStep) {
        moveToStep(true);
      }
    });
  }
  return null;
};
